export const AUTH_INPUT_CLASS_NAME =
  "h-[38px] border-[#ded9f0] bg-[#fbf9ff] text-[12px] focus:border-[#d7cdea] focus:ring-[#eee8f8] sm:h-[40px] sm:text-[13px]";

export const AUTH_LABEL_CLASS_NAME = "text-[#344054]";
